import {CALCULATION_TYPE} from "./common";

export enum HotelScope {
    property = 'PROPERTY',
    city = 'CITY',
    region = 'REGION',
    country = 'COUNTRY'
}

export enum HotelClass {
    zero = 'ZERO',
    one = 'ONE',
    two = 'TWO',
    three = 'THREE',
    four = 'FOUR',
    five = 'FIVE',
}

export enum HotelMealPlan {
    OV = "OV",
    ÜF = "ÜF",
    HP = "HP",
    VP = "HP",
    AI = "AI"
}

export enum HotelRoomCategory {
    SS = "SS",
    DS = "DS",
    SP = "SP",
    DP = "DP",
    S = "S"
}

export interface HotelResponse {
    id: number,
    hotelId: string | null,
    name: string,
    city: string,
    region: string | null,
    alpha2: string,
    alpha3: string,
    countryName: string
    stars: string
}

export interface CityResponse {
    id: number,
    name: string,
    region: string | null,
    alpha2: string,
    alpha3: string,
    countryName: string
}

export interface CountryResponse {
    id: number,
    name: string,
    alpha2: string,
    alpha3: string,
}

/**
 * Data that must be sent to BE for emission calculation of a hotel.
 */
export interface HotelCalculationRequest {
    index: number,
    hotelId: string | null,
    hotelName: string | null,
    city: string,
    region: string | null,
    country: string,
    hotelClass: number | null,
    roomCategory: HotelRoomCategory,
    numberOfRooms: number,
    numberOfNights: number,
    numberOfPeople: number,
    mealPlan: HotelMealPlan | null,
    type: CALCULATION_TYPE
}


